export default __webpack_public_path__ + "static/media/seo-small.87d07956.svg";